import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const registerUser = (data) => api.post('/auth/register', data);
export const loginUser = (data) => api.post('/auth/login', data);
export const getCurrentUser = () => api.get('/auth/me');

// Transactions
export const uploadCSV = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const getTransactions = (limit = 50, skip = 0) =>
  api.get(`/transactions?limit=${limit}&skip=${skip}`);

// Categorize
export const categorizeTransactions = () => api.post('/categorize');

// Forecast
export const getForecast = () => api.get('/forecast');

// Insights
export const getInsights = () => api.get('/insights');

// Health
export const healthCheck = () => api.get('/health');

// Clear data
export const clearData = () => api.delete('/clear-data');

// Chatbot
export const sendChatMessage = (message) => api.post('/chat', { message });

export default api;
